module.exports = __webpack_public_path__ + "static/media/isg-logo-charcoal.c090b881.svg";